import React from 'react';

type Icon3DName =
  | 'wallet-care'
  | 'paw'
  | 'camera'
  | 'pill'
  | 'receipt-check'
  | 'paw-check'
  | 'dog-warning'
  | 'dog'
  | 'cat'
  | 'chart'
  | 'shopping'
  | 'hospital';

interface Icon3DProps {
  name: Icon3DName;
  size?: number;
  alt?: string;
  className?: string;
}

const iconMap: Record<Icon3DName, string> = {
  'wallet-care': '/assets/icons/3d/wallet-care.png',
  paw: '/assets/icons/3d/paw.png',
  camera: '/assets/icons/3d/camera.png',
  pill: '/assets/icons/3d/pill.png',
  'receipt-check': '/assets/icons/3d/receipt-check.png',
  'paw-check': '/assets/icons/3d/paw-check.png',
  'dog-warning': '/assets/icons/3d/dog-warning.png',
  dog: '/assets/icons/3d/dog.png',
  cat: '/assets/icons/3d/cat.png',
  chart: '/assets/icons/3d/chart.png',
  shopping: '/assets/icons/3d/shopping.png',
  hospital: '/assets/icons/3d/hospital.png',
};

export default function Icon3D({
  name,
  size = 40,
  alt,
  className = '',
}: Icon3DProps) {
  return (
    <img
      src={iconMap[name]}
      alt={alt ?? name}
      width={size}
      height={size}
      className={className}
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        display: 'inline-block',
      }}
      loading="lazy"
      draggable={false}
    />
  );
}
